let currentInfoWindow = null;

const initializeMap = () => {
    return new google.maps.Map(document.getElementById("map"), {
        zoom: 6.0,
        center: { lat: 51.0, lng: 10.5 },
        minZoom: 6,
        restriction: {
            latLngBounds: {
                north: 55.05,
                south: 47.27,
                east: 15.04,
                west: 5.87,
            },
        },
        disableDefaultUI: true,
        zoomControl: true,
        scrollwheel: true,
        fullscreenControl: true,
        mapTypeControlOptions: {
            mapTypeIds: ["roadmap"],
        },
        gestureHandling: "auto",
    });
};

const createMarkers = (map, imagePath, locations) => {
    const customIcon = `${imagePath}/location.svg`;
    const isProjectSponsor = Number(window._IS_PROJECT_SPONSOR) === 1;

    locations.forEach((location) => {
        const marker = new google.maps.Marker({
            position: {
                lat: parseFloat(location[0]),
                lng: parseFloat(location[1]),
            },
            map: map,
            icon: {
                url: customIcon,
                scaledSize: new google.maps.Size(62, 62),
            },
            // Attach additional data to the marker
            data: {
                RegNr: location[2],
                Street: location[3],
                City: location[4],
                Contact_Person: location[5],
                phone: location[6],
                Email: location[7],
                Online: location[8],
                Title: location[9],
                ProjectName: location[10]
            },

        });

        // Add a single click listener
        marker.addListener("click", () => {
            if (currentInfoWindow) {
                currentInfoWindow.close();
            }

            const { RegNr, Street, City, Contact_Person, phone, Email, Online, Title, ProjectName } = marker.data;

            const headline = isProjectSponsor && ProjectName && ProjectName.trim() !== "" ? ProjectName : Title;
            const safeHeadline = headline ? String(headline) : "";

            const infoWindow = new google.maps.InfoWindow({
                content: `
                    ${safeHeadline ? `<h3 style="margin-bottom: 20px; font-size: 18px; color: #CF003D">${safeHeadline}</h3>` : ""}
                    ${RegNr ? `<p><strong>Modul:</strong> ${RegNr}</p>` : ''}
                    ${Title ? `<p style="margin-top: 10px;">${Title}</p>` : ''}
                    ${Street ? `<p>${Street}</p>` : ''}
                    ${City ? `<p style="margin-bottom: 20px;">${City}</p>` : ''}
                    ${Contact_Person ? `<p style="margin-top: 5px;margin-bottom: 20px"><strong>Ansprechpartner*in:</strong> ${Contact_Person}</p>` : ''}
                    ${phone ? `<p style="margin-top: 5px;"><strong>Tel: </strong><a href="tel:${phone}">${phone}</a></p>` : ''}
                    ${Email ? `<p style="margin-top: 5px;"><strong>Email: </strong><a href="mailto:${Email}" target="_blank" style="color: red; text-decoration: underline;">${Email}</a></p>` : ''}
                    ${Online ? `<p style="margin-top:5px;"><strong>Online: </strong> <a href="${Online}" target="_blank" style="color: red; text-decoration: underline;">${Online}</a></p>` : ''}
                `,
            });

            infoWindow.open(map, marker);
            currentInfoWindow = infoWindow;

            map.setZoom(10);
            map.setCenter(marker.getPosition());
        });
    });
};


const initMap = () => {
    const imagePath = document.getElementById("js-imagePath").dataset.images;
    const map = initializeMap();

    createMarkers(map, imagePath, locations);
};


// Cookiebot Consent Listener
const checkGoogleMapsConsent = () => {
    if (Cookiebot.consent.marketing) {
        initMap();
    }
}

if (Cookiebot.consent.marketing) {
    window.initMap = initMap;
}

window.addEventListener("CookiebotOnAccept", checkGoogleMapsConsent);
window.addEventListener("CookiebotOnLoad", checkGoogleMapsConsent);



